export default __webpack_public_path__ + "static/media/ic_loyalty_reward.5fe49e5e.svg";